import React, {useContext} from "react";
import UIService from "../../../services/UIService";
import OrderwerksStackedLogo from "../../../assets/images/orderwerks/stacked-logo-grey.svg";
import OrderwerksStackedBlackLogo from "../../../assets/images/orderwerks/stacked-logo-black.svg";
import UserService from "../../../services/UserService";
import OwTitle from "../../shared/OwTitle/OwTitle";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import VendorContext from "../../../contexts/VendorContext";
import * as _ from "lodash-es";
import styled from "styled-components";

export const SplashScreen = () => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const vendorModel = useContext(VendorContext);

    const {supplierLogo, supplierLogoUrl} = UIService.getSupplierLogo(supplierModel, userModel);

    if ((_.isNil(userModel) || _.isNil(supplierModel) || _.isNil(vendorModel))) {
        let orderwerksStackedLogo = OrderwerksStackedLogo;

        let colorMode = "dark";

        if (supplierModel.settings) {
            if (!_.isString(supplierModel.settings)) {
                const themeType = _.get(supplierModel, "settings.theme.type", "DARK");

                // @ts-expect-error
                if (themeType === "LIGHT") {
                    colorMode = "light";
                }
            }

            if (colorMode === "light") {
                orderwerksStackedLogo = OrderwerksStackedBlackLogo;
            }
        }

        const currentToken = UserService.getCurrentToken(userModel);

        if (currentToken?.settings) {
            if (!_.isString(currentToken.settings)) {
                colorMode = currentToken.settings.theme === "LIGHT" ? "light" : "dark";
            }

            if (colorMode === "light") {
                orderwerksStackedLogo = OrderwerksStackedBlackLogo;
            } else {
                orderwerksStackedLogo = OrderwerksStackedLogo;
            }
        }

        return (
            <SplashWrapper
                id={"appLoading"}
                className={"app-loading h-100 w-100 d-flex flex-column justify-content-center align-items-center text-center position-absolute " + colorMode}>
                <div className={"text-center mb-2"}>
                    {!supplierLogo ? (
                        <img src={orderwerksStackedLogo} style={{ width: "9.25rem" }} />
                    ) : (
                        <img src={supplierLogoUrl} style={{ maxWidth: "15rem" }} />
                    )}
                </div>
                <div className={""}>
                    <OwTitle
                        title={"loading"}
                        tag={"h2"}
                        className={"d-flex align-items-center"}
                        leftIconName={"fa-xs fa fa-circle-notch fa-spin"}
                    />
                </div>
            </SplashWrapper>
        );
    } else {
        return null;
    }
};

const SplashWrapper = styled.div`
    top: 0;
    left: 0;
    z-index: 100;
`;
